import { AcademicLevel, Campus, ChoixDocumentation, CityDocumentation, Consentement, CountryDocumentation, Email, FirstName, LastName, MobilePhoneRequired, PostalCodeDocumentation, StreetDocumentation } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...ChoixDocumentation,
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...CityDocumentation,
    ...CountryDocumentation,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...PostalCodeDocumentation,
    ...StreetDocumentation
  })
})

export default schema
